import { render, staticRenderFns } from "./StudentScholarshipIssuedBulkUpload.vue?vue&type=template&id=461c4560"
import script from "./StudentScholarshipIssuedBulkUpload.vue?vue&type=script&lang=js"
export * from "./StudentScholarshipIssuedBulkUpload.vue?vue&type=script&lang=js"
import style0 from "./StudentScholarshipIssuedBulkUpload.vue?vue&type=style&index=0&id=461c4560&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports